// import pacchetti
import { useState } from "react";

// import styles
import "./Project.css";

export default function ProjectDelete({ onDelete }) {
  const [confermaEliminazione, setConfermaEliminazione] = useState(false);

  const handleDeleteClick = () => {
    if (!confermaEliminazione) {
      setConfermaEliminazione(true);
    } else {
      onDelete();
    }
  };

  const annullaEliminazione = () => {
    setConfermaEliminazione(false);
  };

  return (
    <div className="project-section delete-actions">
      {!confermaEliminazione ? (
        <button className="btn" onClick={handleDeleteClick}>
          Elimina Cantiere
        </button>
      ) : (
        <div className="confirm-delete">
          <p className="warning">
            Sei sicuro di voler eliminare questo cantiere?
          </p>
          <div className="confirm-buttons">
            <button className="btn btn-danger" onClick={handleDeleteClick}>
              Conferma Eliminazione
            </button>
            <button
              className="btn btn-secondary"
              onClick={annullaEliminazione}
            >
              Annulla
            </button>
          </div>
        </div>
      )}
    </div>
  );
}